import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

export default function SavedJobs() {
  const [jobs, setJobs]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');

  useEffect(() => {
    fetch('http://localhost:5000/api/users/saved-jobs', {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then(r => r.json())
      .then(data => { setJobs(Array.isArray(data) ? data : []); setLoading(false); })
      .catch(() => { setError('Failed to load saved jobs'); setLoading(false); });
  }, []);

  const handleUnsave = async (jobId) => {
    await fetch(`http://localhost:5000/api/users/save-job/${jobId}`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    setJobs(jobs.filter(j => j._id !== jobId));
  };

  return (
    <>
      <PageHeader title="Saved Jobs" breadcrumb="Saved Jobs" />
      <section className="section-pad">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Dashboard</span>
            <h2 className="section-title">Saved Jobs</h2>
            <p className="section-sub">Jobs you've bookmarked for later</p>
          </div>

          {loading && <div className="text-center py-5"><i className="fa fa-spinner fa-spin fa-2x text-primary"></i></div>}
          {error   && <div className="auth-alert error"><i className="fa fa-exclamation-circle me-2"></i>{error}</div>}

          {!loading && jobs.length === 0 && (
            <div className="jl-empty">
              <i className="far fa-heart"></i>
              <h5>No saved jobs yet</h5>
              <p>Click the heart icon on any job to save it here</p>
              <Link to="/job-list" className="btn-grad mt-3">Browse Jobs</Link>
            </div>
          )}

          {!loading && jobs.length > 0 && (
            <div className="jobs-list">
              {jobs.map((job, i) => (
                <div className="job-card-pro" key={i}>
                  <div className="job-card-left">
                    <div className="job-logo-wrap">
                      {job.logo
                        ? <img src={job.logo} alt="" />
                        : <div style={{ width: '100%', height: '100%', background: '#e8f0ff', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0066FF', fontSize: 22 }}><i className="fa fa-building"></i></div>
                      }
                    </div>
                    <div className="job-info">
                      <div className="job-top-row">
                        <h5>{job.title}</h5>
                        <span className={`job-tag tag-${job.tag?.toLowerCase()}`}>{job.tag}</span>
                      </div>
                      <p style={{ fontSize: 13, color: '#888', margin: '0 0 8px' }}>{job.company}</p>
                      <div className="job-meta">
                        <span><i className="fa fa-map-marker-alt"></i>{job.location}</span>
                        <span><i className="far fa-clock"></i>{job.type}</span>
                        <span><i className="far fa-money-bill-alt"></i>{job.salary}</span>
                        <span><i className="far fa-calendar-alt"></i>Deadline: {new Date(job.deadline).toLocaleDateString()}</span>
                      </div>
                    </div>
                  </div>
                  <div className="job-card-right">
                    <button className="jl-save-btn saved" onClick={() => handleUnsave(job._id)} title="Remove from saved">
                      <i className="fa fa-heart"></i>
                    </button>
                    <Link to="/job-detail" className="jl-apply-btn">Apply Now</Link>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
